import api from '@/plugins/api'
import { accountOC, moderationQuestionOC } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
import { wrongFields } from '@/configs/constants'

const store = 'certificationAgency'

export default {
  state: () => ({
    idCertificationAgency: null,
    idLaboratory: null,
    laboratories: [],
    laboratory: {},
    statistic: {},
    certificationAgency: {},
    certificationAgencyBranches: {},
    certificationAgencyStatementBranches: {},
    certificationAgencyBranch: {},
    employees: [],
    employee: [],
    typeInsurance: [
      { name: 'Страховий Фонд', value: 0 },
      { name: 'Договір страхування відповідальності', value: 1 }
    ],
    
    moderationQuestionOC: [],
    moderationFileQuestionOC: [],
    moderationDirectorFileQuestionOC: [],
    
    moderationBranchQuestionOC: {},
    hasModerationWrongBranch: false,
    moderationEmployeeQuestionOC: {},
    moderationEmployeeFileQuestionOC: {},
    countWrongEmployee: 0
  }),
  mutations: {
    // DELETE_EMPLOYEE (state, id) {
    //   state.employees.results = state.employees.results.filter(employee => employee.id !== id)
    // },
    UPDATE_EMPLOYEE (state, data) {
      let index = state.employees.results.findIndex(e => e.id === data.id)
      if (index !== -1) {
        state.employees.results.splice(index, 1, data)
      }
    },
    SET_BRANCH_QUERY (state, data) {
      state.moderationBranchQuestionOC = Object.assign({}, state.moderationBranchQuestionOC, data)
    },
    SET_EMPLOYEE_QUESTION (state, data) {
      state.moderationEmployeeQuestionOC = Object.assign({}, state.moderationEmployeeQuestionOC, data)
    },
    SET_EMPLOYEE_FILE_QUESTION (state, data) {
      state.moderationEmployeeFileQuestionOC = Object.assign({}, state.moderationEmployeeFileQuestionOC, data)
    }
  },
  getters: {
    reprocessingTypeReviewOC: state => {
      // previous_statement_step: type_review
      let typeReviewByPrevStatus = {
        6: 1,
        7: 2,
        3: 3
      }

      const previousStatementStep = state.certificationAgency?.results?.length
        ? state.certificationAgency.results[0].previous_statement_step
        : state.certificationAgency?.previous_statement_step

      if (previousStatementStep !== undefined && previousStatementStep !== null) {
        return typeReviewByPrevStatus[previousStatementStep]
      }
    },
    wrongFieldByType: (state, getters, rootState) => (organization, stateName, part) => {
      let store = organization === 'OC' ? 'certificationAgency' : 'accountVL'
      return rootState[store][stateName].filter(q => {
        return wrongFields[organization][part].includes(q.check_list_question.field_name)
      }).map(e => ({ field_name: e.check_list_question.field_name, comment: e.comment }))
    },
    wrongFileByType: (state, getters, rootState) => (organization, stateName, part) => {
      let store = organization === 'OC' ? 'certificationAgency' : 'accountVL'
      return rootState[store][stateName].filter(q => {
        return wrongFields[organization][part].includes(q.file_type)
      }).map(e => ({ field_name: e.file_type, comment: e.comment }))
    }
  },
  actions: {
    // REGISTRATION START
    async registrationCertificationAgency (context, body) {
      const response = await api.post(accountOC.registrationCertificationAgency, { body: body })
      const res = await requestValidation(response)
      if (res) {
        context.commit('SET_DATA', { store, state: 'idCertificationAgency', data: response.data.id })
        return response.data.id
      }
      return res
    },
    async getInfoUasApiKey () {
      const response = await api.get(accountOC.uasInfoApiKey)
      const res = await requestValidation(response)
      if (!res) return false
      return response.data
    },
    async setApiUasKey (_, body) {
      const response = await api.post(accountOC.uasInfoApiKey, { body })
      const res = await requestValidation(response)
      if (!res) return false
      return response.data
    },
    async updateCertificationAgencyInRegistration (context, data) {
      const response = await api.patch(accountOC.updateCertificationAgencyInRegistration(data.id), { body: data.body })
      return await requestValidation(response)
    },
    certificationAgencyUpdateFilesInRegistration (context, data) {
      return Promise.all(data.items.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)
        
        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.put(accountOC.certificationAgencyUpdateFileInRegistration(data.id), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    async getStepRegistrationCertificationAgency (context, step) {
      const response = await api.get(`${ accountOC.registrationCertificationAgency }?page=${ step }`)
      const res = await requestValidation(response)
      if (await res) {
        context.commit('SET_DATA', { store, state: 'certificationAgency', data: response.data })
        return response.data
      }
      return res
    },
    async certificationAgencyRemoveFileInRegistration (context, data) {
      const response = await api.delete(accountOC.certificationAgencyRemoveFileInRegistration(data.agency_id, data.file_id))
      return await requestValidation(response)
    },
    async addAccreditationEmployee (context, data) {
      const response = await api.post(accountOC.accreditationEmployee(data.id), { body: data.employee })
      const res = await requestValidation(response)
      if (res) {
        return response.data
      }
      return res
    },
    async updateAccreditationEmployee (context, data) {
      const response =
        await api.patch(accountOC.updateAndRemoveAccreditationEmployee(
          data.idCertificationAgency, data.employeeId), { body: data.employee })
      return await requestValidation(response)
    },
    async removeAccreditationEmployee (context, data) {
      const response = await api.delete(accountOC.updateAndRemoveAccreditationEmployee(data.id, data.employeeId))
      return await requestValidation(response)
    },
    async getAccreditationEmployees (context, id) {
      const response = await api.get(accountOC.accreditationEmployee(id))
      const res = await requestValidation(response)
      if (res) {
        context.commit('SET_DATA', { store, state: 'employees', data: response.data })
      }
      return res
    },
    accreditationEmployeeUploadFiles (context, data) {
      return Promise.all(data.documents.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)
        
        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.post(accountOC.accreditationEmployeeUploadFiles(
          data.idCertificationAgency, data.idEmployee), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    accreditationEmployeeUpdateFiles (context, data) {
      return Promise.all(data.documents.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)
        
        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.put(accountOC.accreditationEmployeeUpdateFiles(
          data.idCertificationAgency, data.idEmployee), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    // async accreditationEmployeeDeleteFiles (context, data) {
    //   const response = await api.delete(accountOC.certificationAgencyRemoveFile(data.agency_id, data.file_id))
    //   return await requestValidation(response)
    // },
    // REGISTRATION END
    async updateCertificationAgency (context, data) {
      const response = await api.patch(accountOC.updateCertificationAgency(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'idCertificationAgency', data: response.data.id })
        context.commit('SET_DATA', { store, state: 'certificationAgency', data: response.data })
      }
      return isResult
    },
    certificationAgencyUploadFile (context, data) {
      return Promise.all(data.items.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)
        
        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.post(accountOC.certificationAgencyUploadFile(data.id), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    certificationAgencyUpdateFiles (context, data) {
      return Promise.all(data.items.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)
        
        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.put(accountOC.certificationAgencyUpdateFiles(data.id), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    async getCertificationAgency (context, id) {
      const response = await api.get(accountOC.getCertificationAgency(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'certificationAgency', data: response.data })
      }
      return await requestValidation(response)
    },
    async certificationAgencyRemoveFile (context, data) {
      const response =
        await api.delete(accountOC.accreditationEmployeeDeleteFiles(data.agency_id, data.employee_id, data.file_id))
      return await requestValidation(response)
    },
    async getBranchesCertificationAgency (context, filter) {
      const params = new URLSearchParams()
      for (let field in filter) {
        filter[field] && params.append(field, filter[field])
      }
      const response = await api.get(`${ accountOC.getAndPostBranchesCertificationAgency }?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'certificationAgencyBranches', data: response.data })
      }
    },
    async addBranchCertificationAgency (context, body) {
      const response = await api.post(accountOC.getAndPostBranchesCertificationAgency, { body: body })
      return await requestValidation(response)
    },
    async getStatementBranchesCertificationAgency (context, filter = {}) {
      const params = new URLSearchParams()
      for (let field in filter) {
        filter[field] && params.append(field, filter[field])
      }
      const response = await api.get(`${ accountOC.getAndPostStatementBranchesCertificationAgency }?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'certificationAgencyStatementBranches', data: response.data })
      }
      return await requestValidation(response)
    },
    async getStatementBranchCertificationAgency (context, id) {
      const response = await api.get(accountOC.statementBranchCertificationAgency(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'certificationAgencyBranch', data: response.data })
      }
      return await requestValidation(response)
    },
    async updateStatementBranchCertificationAgency (context, data) {
      const response = await api.patch(accountOC.statementBranchCertificationAgency(data.id), { body: data.body })
      return await requestValidation(response)
    },
    async deleteBranchCertificationAgency (context, id) {
      const response = await api.delete(accountOC.branchCertificationAgency(id))
      return await requestValidation(response)
    },
    async addEmployees (context, data) {
      const response = await api.post(accountOC.addEmployees(data.id), { body: data.employees })
      return await requestValidation(response)
    },
    async getBranchCertificationAgency (context, id) {
      const response = await api.get(accountOC.branchCertificationAgency(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'certificationAgencyBranch', data: response.data })
      }
      return await requestValidation(response)
    },
    async updateBranchCertificationAgency (context, data) {
      const response = await api.patch(accountOC.branchCertificationAgency(data.id), { body: data.body })
      return await requestValidation(response)
    },
    
    // Статистика
    async getStatistic (context, filter) {
      let filterParams = Object.keys(filter).filter(key => !!filter[key]).map(key => key + '=' + filter[key]).join('&')
      const response = await api.get(accountOC.getStatistic(filterParams))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statistic', data: response.data })
      }
      return await requestValidation(response)
    },
    async getStatisticRegister (context, filter) {
      let filterParams = Object.keys(filter).filter(key => !!filter[key]).map(key => key + '=' + filter[key]).join('&')
      const response = await api.get(accountOC.getStatisticUasRegister(filterParams))
      if (await requestValidation(response)) {
        return response.data
      }
      return await requestValidation(response)
    },
    async filterStatistic (context, params) {
      const response = await api.get(accountOC.filterStatistic(params))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statistic', data: response.data })
      }
      return await requestValidation(response)
    },
    // ADD SYSTEMIC EMPLOYEES and OUT OF SYSTEM EMPLOYEES START
    async addSystemicAndOutOfSystemEmployee (context, body) {
      const response = await api.post(accountOC.outOfSystemEmployees, { body: body })
      const res = await requestValidation(response)
      if (res) return response.data
      return res
    },
    systemicAndOutOfSystemEmployeeUploadFiles (context, data) {
      return Promise.all(data.documents.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)
        
        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.post(accountOC.systemicAndOutOfSystemEmployeeUploadFiles(data.idEmployee), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    outOfSystemEmployeeUpdateFiles (context, data) {
      return Promise.all(data.documents.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)
        
        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.put(accountOC.outOfSystemEmployeeUpdateFiles(data.idEmployee), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    // ADD SYSTEMIC EMPLOYEES and OUT OF SYSTEM EMPLOYEES END
    // SYSTEMIC EMPLOYEES START
    async getEmployees (context, page = 1, pageSize = 10 ) {
      const params = new URLSearchParams()
      params.append('page_size', String(pageSize))
      params.append('page', String(page))

      const response = await api.get(accountOC.employees + '?' + params)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'employees', data: response.data })
      }
      return await requestValidation(response)
    },
    async getModerationEmployees (context, data = {}) {
      const params = new URLSearchParams()
      params.append('page_size', String(data.page_size || 10))
      params.append('page', String(data.page || 1))

      const response = await api.get(`${ accountOC.moderationEmployees }?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'employees', data: response.data })
      }
      return await requestValidation(response)
    },
    async getEmployee (context, id) {
      const response = await api.get(accountOC.employee(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'employee', data: response.data })
      }
      return await requestValidation(response)
    },
    async deactivateAndActivateEmployee (context, body) {
      const response = await api.patch(accountOC.employee(body.id), { body: body })
      if (await requestValidation(response)) {
        context.commit('UPDATE_EMPLOYEE', response.data)
      }
      return await requestValidation(response)
    },
    async updateEmployee (context, body) {
      const response = await api.patch(accountOC.employee(body.id), { body: body })
      const res = await requestValidation(response)
      if (res) return response.data
      return res
    },
    async updateEmployeeCabinet (context, body) {
      const response = await api.patch(accountOC.employeeCabinet(body.id), { body: body })
      const res = await requestValidation(response)
      if (res) return response.data
      return res
    },
    employeeUpdateFiles (context, data) {
      return Promise.all(data.documents.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)
        
        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.put(accountOC.employeeUpdateFiles(data.idEmployee), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    employeeUpdateFilesCabinet (context, data) {
      const isUploadableFile = file => file instanceof File || file instanceof Blob
      const getUploadable = file => {
        if (isUploadableFile(file)) return file
        if (file && typeof file === 'object' && isUploadableFile(file.file)) return file.file
        return null
      }

      const requestList = data.documents
        .map(item => ({
          type: item.type,
          files: (item.files || []).map(getUploadable).filter(Boolean)
        }))
        .filter(item => item.files.length)
        .map(async item => {
          const body = new FormData()
          body.append('type_file', item.type)
          item.files.forEach(file => body.append('files', file))
          return await api.patch(accountOC.employeeCabinetUpdateFiles(data.idEmployee), { body: body })
        })

      if (!requestList.length) return true
      return Promise.all(requestList).then(response => response.every(async r => await requestValidation(r)))
    },
    // SYSTEMIC EMPLOYEES END
    // OUT OF SYSTEM EMPLOYEES START
    async getOutOfSystemEmployees (context) {
      const response = await api.get(accountOC.outOfSystemEmployees)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'employees', data: response.data })
      }
      return await requestValidation(response)
    },
    async getOutOfSystemEmployee (context, id) {
      const response = await api.get(accountOC.outOfSystemEmployee(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'employee', data: response.data })
      }
      return await requestValidation(response)
    },
    async updateOutOfSystemEmployee (context, body) {
      const response = await api.patch(accountOC.outOfSystemEmployee(body.id), { body: body })
      const res = await requestValidation(response)
      if (res) return response.data
      return res
    },
    async deactivateAndActivateOutOfSystemEmployee (context, body) {
      const response = await api.patch(accountOC.outOfSystemEmployee(body.id), { body: body })
      if (await requestValidation(response)) {
        context.commit('UPDATE_EMPLOYEE', response.data)
      }
      return await requestValidation(response)
    },
    // OUT OF SYSTEM EMPLOYEES END
    
    // Reprocessing OC
    async getMainQuestionOC (context, id) {
      let typeReview = context.getters.reprocessingTypeReviewOC
      const query = typeReview !== undefined ? `?answer=2&type_review=${ typeReview }` : '?answer=2'
      const response = await api.get(`${ moderationQuestionOC.mainQuestion(id) }${ query }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'moderationQuestionOC', data: response.data })
      }
    },
    async getFileQuestionOC (context, id) {
      let typeReview = context.getters.reprocessingTypeReviewOC
      const query = typeReview !== undefined ? `?answer=2&type_review=${ typeReview }` : '?answer=2'
      const response = await api.get(`${ moderationQuestionOC.mainQuestionFile(id) }${ query }`)
      
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'moderationFileQuestionOC', data: response.data })
      }
    },
    async getDirectorFileQuestionOC (context, id) {
      let typeReview = context.getters.reprocessingTypeReviewOC
      const query = typeReview !== undefined ? `?answer=2&type_review=${ typeReview }` : '?answer=2'
      const response = await api.get(`${ moderationQuestionOC.directorFile(id) }${ query }`)
      
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'moderationDirectorFileQuestionOC', data: response.data })
      }
    },
    
    async getBranchListOC (context, id) {
      const response = await api.get(`${ moderationQuestionOC.branchList(id) }`)
      if (await requestValidation(response)) {
        let branchHasWrong = !!response.data.results.filter(e => e.has_rejected_reviews).length
        context.commit('SET_DATA', { store, state: 'hasModerationWrongBranch', data: branchHasWrong })
        
        response.data.results.forEach(item => {
          context.dispatch('getBranchQuestionOC', { id: id, branchId: item.id })
        })
      }
    },
    async getBranchQuestionOC (context, data) {
      let typeReview = context.getters.reprocessingTypeReviewOC
      const endpoint = data.isCabinet
        ? moderationQuestionOC.branchItemCabinet({
          id: data.id,
          branchId: data.branchId
        })
        : moderationQuestionOC.branchItem({
          id: data.id,
          branchId: data.branchId
        })
      if (data.isCabinet) typeReview = 3
      const query = typeReview !== undefined ? `?answer=2&type_review=${ typeReview }` : '?answer=2'
      const response = await api.get(`${ endpoint }${ query }`)
      if (await requestValidation(response) && response.data.length) {
        let branchItem = {
          [data.branchId]: response.data.map(e => ({
            field_name: e.check_list_question.field_name,
            comment: e.comment
          }))
        }
        context.commit('SET_BRANCH_QUERY', branchItem)
      }
    },
    
    async getEmployeeListOC (context, payload) {
      const id = typeof payload === 'object' ? payload.id : payload
      const isCabinet = typeof payload === 'object' ? payload.isCabinet : false
      const endpoint = isCabinet ? moderationQuestionOC.employeeListCabinet(id) : moderationQuestionOC.employeeList(id)
      const response = await api.get(`${ endpoint }`)
      if (await requestValidation(response)) {
        let employeeHasWrong = response.data.filter(e => e.has_rejected_reviews)
        context.commit('SET_DATA', { store, state: 'countWrongEmployee', data: employeeHasWrong.length })
        employeeHasWrong.forEach(item => {
          context.dispatch('getEmployeeQuestionOC', { id: id, employeeId: item.id, isCabinet })
          context.dispatch('getEmployeeFileQuestionOC', { id: id, employeeId: item.id, isCabinet })
        })
      }
    },
    
    async getEmployeeQuestionOC (context, data) {
      let typeReview = context.getters.reprocessingTypeReviewOC
      const endpoint = data.isCabinet
        ? moderationQuestionOC.employeeItemCabinet({ id: data.id, employeeId: data.employeeId })
        : moderationQuestionOC.employeeItem({ id: data.id, employeeId: data.employeeId })
      if (data.isCabinet) typeReview = 3
      const query = typeReview !== undefined ? `?answer=2&type_review=${ typeReview }` : '?answer=2'
      const response = await api.get(`${ endpoint }${ query }`)
      if (await requestValidation(response) && response.data.length) {
        let employeeItem = {
          [data.employeeId]: response.data.map(e => ({
            field_name: e.check_list_question.field_name,
            comment: e.comment
          }))
        }
        context.commit('SET_EMPLOYEE_QUESTION', employeeItem)
      }
    },
    
    async getEmployeeFileQuestionOC (context, data) {
      let typeReview = context.getters.reprocessingTypeReviewOC
      const endpoint = data.isCabinet
        ? moderationQuestionOC.employeeFileCabinet({ id: data.id, employeeId: data.employeeId })
        : moderationQuestionOC.employeeFile({ id: data.id, employeeId: data.employeeId })
      if (data.isCabinet) typeReview = 3
      const query = typeReview !== undefined ? `?answer=2&type_review=${ typeReview }` : '?answer=2'
      const response = await api.get(`${ endpoint }${ query }`)
      
      if (await requestValidation(response)) {
        let employeeFile = {
          [data.employeeId]: response.data.map(e => ({ field_name: e.file_type, comment: e.comment }))
        }
        context.commit('SET_EMPLOYEE_FILE_QUESTION', employeeFile)
      }
    },
    
  }
}
